import { Star } from "lucide-react";

export const StarRating = ({ rating, size = "default", interactive = false, onRate }) => {
  const sizeClasses = {
    sm: "w-3 h-3",
    default: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const starSize = sizeClasses[size] || sizeClasses.default;

  return (
    <div className="flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type={interactive ? "button" : undefined}
          onClick={() => interactive && onRate && onRate(star)}
          className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
          disabled={!interactive}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${starSize} ${
              star <= rating ? "fill-amber-400 text-amber-400" : "fill-gray-200 text-gray-200"
            }`}
          />
        </button>
      ))}
    </div>
  );
};

export const RatingDisplay = ({ rating, reviewCount, size = "default" }) => {
  return (
    <div className="flex items-center gap-2" data-testid="rating-display">
      <StarRating rating={Math.round(rating)} size={size} />
      <span className="text-[#4A4A4A] text-sm">
        {rating > 0 ? rating.toFixed(1) : "No ratings"} 
        {reviewCount > 0 && <span className="text-[#71717A]"> ({reviewCount})</span>}
      </span>
    </div>
  );
};

export default StarRating;
